import React, { Component } from "react";
import PaymentConfigDrawer from "./PaymentConfigDrawer";
import * as constants from "../../../../Constatnts"; // Adjust path as needed
import axios from "axios";
import ListingPage from "../../Controls/ListingPage";
import Window from "../../Controls/Window";

// API Functions
const fetchPaymentConfigs = async (registrationId, gateway, getState) => {
  try {
    const token = getState().user.uat;
    const response = await axios.get(
      `${constants.API_URL}/integration/paymentconfig/${registrationId}/${gateway}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payment configs:", error.response || error.message);
    throw error;
  }
};

const savePaymentConfig = async (payload, getState) => {
  try {
    const user = getState().user.user;
    const token = getState().user.uat;
    
    const enrichedPayload = {
      ...payload,
      ActionOn: new Date().toISOString(),
      ActionBy: user.Name,
      ActionByUID: user.UID,
      ActionByEmailID: user.EmailID,
      RegistrationID: user.RegistrationID,
    };
    
    const response = await axios.post(
      `${constants.API_URL}/integration/paymentconfig`,
      enrichedPayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving payment config:", error.response || error.message);
    throw error;
  }
};



class PaymentCredentialsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      configuredConfigs: [],
      configuredMap: {},
      storesWithoutConfig: [],
      storesWithConfig: [],
      drawerOpen: false,
      selectedStoreForDrawer: null,
      editData: null,
      expandedRegisters: {},
      errorMsg: "",
      showNewStoreModal: false,
      newStoreId: "",
      loadingCashRegister: false,
      registrationId: null,
      gateway: null,
      cashRegisters: [],
    };
  }


  componentDidMount() {
    const locationState = this.props.location && this.props.location.state;
    const registrationId = locationState && locationState.hasOwnProperty('registrationId') ? locationState.registrationId : undefined;
    const gateway = locationState && locationState.hasOwnProperty('gateway') ? locationState.gateway : undefined;
    console.log("registrationId",registrationId,"gateway",gateway);
    this.setState({ registrationId, gateway }, () => {
      this.fetchConfigured();
    });
  }

  componentDidUpdate(prevProps) {
    const locationState = this.props.location && this.props.location.state;
    const prevLocationState = prevProps.location && prevProps.location.state;
    
    const registrationId = locationState && locationState.hasOwnProperty('registrationId') ? locationState.registrationId : undefined;
    const gateway = locationState && locationState.hasOwnProperty('gateway') ? locationState.gateway : undefined;
    const prevRegistrationId = prevLocationState && prevLocationState.hasOwnProperty('registrationId') ? prevLocationState.registrationId : undefined;
    const prevGateway = prevLocationState && prevLocationState.hasOwnProperty('gateway') ? prevLocationState.gateway : undefined;

    if (registrationId !== prevRegistrationId || gateway !== prevGateway) {
      this.setState({ registrationId, gateway }, () => {
        this.fetchConfigured();
      });
    }
  }

  fetchCashRegister = async (storeId) => {
      try {
      let cashRegisters = await this.props.getCashRegisters(storeId);
       this.setState({ cashRegisters: cashRegisters });
      return cashRegisters;
  } catch (error) {
    console.error("Error fetching cash registers:", error.response || error.message);
    throw error;
  }
  };

  openDrawerForStore = async (storeId) => {

   const storesList = this.props.config.UserStores.filter(
  store => store.key !== ""
);
    const store = storesList.find((s) => s.key === storeId);
    if (!store) return;

      const { configuredMap } = this.state;
    this.setState({  editData: configuredMap[storeId] || null, drawerOpen: true, loadingCashRegister: true });

    try {
      const cashRegisters = await this.fetchCashRegister(storeId);
    
   
      this.setState({
        selectedStoreForDrawer: {
          storeId: store.key,
          storeName: store.StoreName,
          cashRegisters: cashRegisters || [],
        },
        loadingCashRegister: false,
      });
    } catch (err) {
      console.error("Error fetching registers:", err);
      alert("Failed to fetch cash registers for the store.");
      this.setState({ loadingCashRegister: false });
    }
  };

  fetchConfigured = async () => {
    const { registrationId, gateway } = this.state;
    const storesList = this.props.config.UserStores.filter(
  store => store.key !== ""
);
console.log("StoreList",storesList);

    if (!registrationId || !gateway) return;

    try {
      this.setState({ loading: true, errorMsg: "" });

      const resp = await fetchPaymentConfigs(registrationId, gateway, () => this.props);

      const dataArray = resp.data || [];
      const map = {};
      dataArray.forEach((cfg) => {
        if (cfg.storeId) map[cfg.storeId] = cfg;
      });

      const configuredIds = Object.keys(map);

      this.setState({
        configuredConfigs: dataArray,
        configuredMap: map,
        storesWithConfig: storesList.filter((st) => configuredIds.includes(st.key)),
        storesWithoutConfig: storesList.filter((st) => !configuredIds.includes(st.key)),
        loading: false,
      });
    } catch (err) {
      console.error("Error fetching configured gateways:", err);
      let errorMessage = "Failed to fetch configured gateways.";
      if (err && err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      this.setState({
        errorMsg: errorMessage,
        configuredConfigs: [],
        configuredMap: {},
        storesWithConfig: [],
        storesWithoutConfig: storesList || [],
        loading: false,
      });
    }
  };

  loadRegistersForStore = async (storeId) => {
    if (!storeId) return;

    const { expandedRegisters } = this.state;

    if (expandedRegisters[storeId] && expandedRegisters[storeId].hasOwnProperty('registers') && expandedRegisters[storeId].registers) {
      this.setState({
        expandedRegisters: {
          ...expandedRegisters,
          [storeId]: {
            ...expandedRegisters[storeId],
            expanded: !expandedRegisters[storeId].expanded,
          },
        },
      });
      return;
    }

    this.setState({
      expandedRegisters: {
        ...expandedRegisters,
        [storeId]: {
          loading: true,
          registers: null,
          error: null,
          expanded: true,
        },
      },
    });

    try {
      const cashRegisters = await this.fetchCashRegister(storeId);
      this.setState({
        expandedRegisters: {
          ...this.state.expandedRegisters,
          [storeId]: {
            loading: false,
            registers: cashRegisters || [],
            error: null,
            expanded: true,
          },
        },
      });
    } catch (err) {
      console.error("Error loading registers:", err);
      this.setState({
        expandedRegisters: {
          ...this.state.expandedRegisters,
          [storeId]: {
            loading: false,
            registers: [],
            error: "Failed to load registers",
            expanded: true,
          },
        },
      });
    }
  };

  handleSaveToServer = async (payload) => {
    try {
      this.setState({ loading: true });

      await savePaymentConfig(payload, () => this.props);

      this.setState({
        drawerOpen: false,
        editData: null,
        selectedStoreForDrawer: null,
      });

      await this.fetchConfigured();
    } catch (err) {
      console.error(err);
      let errorMessage = "Save failed";
      if (err && err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      alert(errorMessage);
    } finally {
      this.setState({ loading: false });
    }
  };

  startNewStoreSetup = () => {
    const { newStoreId } = this.state;
    if (!newStoreId) {
      alert("Select a store to start setup.");
      return;
    }
    this.setState({ showNewStoreModal: false });
    this.openDrawerForStore(newStoreId);
  };

  handleBack = () => {
    this.props.navigate(-1);
  };

  render() {
    const {
      storesList = this.props.config.UserStores.filter(
  store => store.key !== ""
)
    } = this.props;
 console.log("storeList",storesList);
    const {
      loading,
      configuredMap,
      drawerOpen,
      selectedStoreForDrawer,
      editData,
      loadingCashRegister,
      registrationId,
      gateway,
      showNewStoreModal,
      newStoreId,
      storesWithoutConfig,
    } = this.state;

    const gatewayName = (gateway && gateway.toUpperCase) ? gateway.toUpperCase() : "Payment";

   const columns = [
    {
      Name: "StoreName",  // Changed from "Store" to match the field name
      Type: "text",
    },
    {
      Name: "CashRegisters_Display",  // This should match the key in row object
      Type: "text",
    },
    {
      Name: "Status_Display",  // This should match the key in row object
      Type: "text",
    },
    {
      Name: "Actions",
      Type: "text",
    },
  ];

    const rowButtons = [
      {
        ButtonType: "button",
        Type: "secondary",
        Text: "Setup",
        Icon: "settings",
        condition: (row) => !configuredMap[row.key],
        onClick: (button, row) => {
          this.openDrawerForStore(row.key);
        },
      },
      {
        ButtonType: "button",
        Type: "primary",
        Text: "Edit Setup",
        Icon: "edit",
        condition: (row) => configuredMap[row.key],
        onClick: (button, row) => {
          this.openDrawerForStore(row.key);
        },
      },
    ];

    const listPageSettings = {
      Title: `${gatewayName} - Store Setup`,
      Search: {
        showSearch: false,
      },
      Columns: columns,
      RowButtons: rowButtons,
      HeaderButtons: [],
    };

   const rows = storesList.map((store) => {
    const cfg = configuredMap[store.key];
    let terminals = [];
    if (cfg && cfg.hasOwnProperty('terminals')) {
      terminals = cfg.terminals.filter((t) => t.terminalId) || [];
    }

    return {
      key: store.key,
      StoreName: store.StoreName,  // Add this for the column to access
      CashRegisters_Display: cfg ? (
        <div style={{ fontSize: "13px" }}>
          Terminals configured: <strong>{terminals.length}</strong>
        </div>
      ) : (
        <div style={{ fontSize: "13px", color: "#6b7280" }}>
          No terminal mapping yet
        </div>
      ),
      Status_Display: cfg ? (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            backgroundColor: "#ecfdf5",
            color: "#047857",
          }}
        >
          ✅ Configured
        </span>
      ) : (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            backgroundColor: "#fefce8",
            color: "#854d0e",
          }}
        >
          ⚠️ Not Configured
        </span>
      ),
    };
  });

  console.log("Rows being passed to ListingPage:", rows); 

    return (
      <div>
        <ListingPage
          {...this.props}
          listPageSettings={listPageSettings}
          list={rows}
          loading={loading}
          onRowButtonClicked={(button, row) => {
            if (button.hasOwnProperty('onClick') && button.onClick) {
              button.onClick(button, row);
            }
          }}
          onHeaderButtonClicked={() => {}}
        />

        {/* New Store Setup Modal using Window */}
        {showNewStoreModal && (
          <Window
            header="New Store Setup"
            size="small"
            modal={true}
            onClose={() => this.setState({ showNewStoreModal: false })}
            buttons={[
              {
                Text: "Cancel",
                Type: "secondary",
                Align: "left",
              },
              {
                Text: "Start Setup",
                Type: "primary",
                Align: "right",
              },
            ]}
            onButtonClick={(buttonText) => {
              if (buttonText === "Start Setup") {
                this.startNewStoreSetup();
              } else {
                this.setState({ showNewStoreModal: false });
              }
            }}
          >
            <div style={{ padding: "16px" }}>
              <p style={{ fontSize: "14px", color: "#4b5563", marginBottom: "16px" }}>
                Select a store (only stores without existing setup are shown)
              </p>
              <select
                value={newStoreId}
                onChange={(e) => this.setState({ newStoreId: e.target.value })}
                style={{
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "4px",
                  padding: "8px",
                  marginBottom: "16px",
                }}
              >
                <option value="">-- Select Store --</option>
                {storesWithoutConfig.map((s) => (
                  <option key={s.key} value={s.key}>
                    {s.StoreName}
                  </option>
                ))}
              </select>
            </div>
          </Window>
        )}

        {/* Payment Config Drawer */}
    {this.state.drawerOpen && (
  <PaymentConfigDrawer
    {...this.props}
    onClose={() => {
      this.setState({
        drawerOpen: false,
        editData: null,
        selectedStoreForDrawer: null,
      });
    }}
    storeData={selectedStoreForDrawer}
    editData={editData}
    onSave={this.handleSaveToServer}
    loadingCashRegister={loadingCashRegister}
    registrationId={registrationId}
  />
)}
      </div>
    );
  }
}

export default PaymentCredentialsList;